import React from 'react';
import { classes as tsClasses } from 'typestyle';

/** Helper that uses same rules as styledTemplate to be used to wrap any renderer now */
export function decorateTextByClasses(children: React.ReactNode, classes: string[] = []) {
  const cssFlags: string[] = [];
  if (classes.includes('bold')) cssFlags.push('bold');
  if (classes.includes('italic')) cssFlags.push('italic');
  if (classes.includes('alignRight')) cssFlags.push('alignRight');
  if (classes.includes('alignLeft')) cssFlags.push('alignLeft');
  if (classes.includes('empty')) cssFlags.push('s5-displayNone');

  // allow values like "red", "#00aaff", "rgb(0,0,0)", etc.
  const colorClass = classes.find((c) => /^color_\w+/i.test(c));
  const fontColor = colorClass ? colorClass.replace('color_', '') : undefined;
  // NEW: support background color of cells
  const bgClass = classes.find((c) => /^backgroundColor_(.+)$/i.test(c));
  const backgroundColor = bgClass ? bgClass.replace(/^backgroundColor_/i, '') : undefined;

  const style: React.CSSProperties | undefined =
    fontColor || backgroundColor
      ? {
          ...(fontColor ? { color: fontColor } : {}),
          ...(backgroundColor ? { backgroundColor } : {}),
        }
      : undefined;

  return (
    <span className={cssFlags.length ? tsClasses(...cssFlags) : undefined} style={style}>
      {children}
    </span>
  );
}
